import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faq } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-title" className="bg-cream py-12 md:py-20" data-id="element-33" data-mp="1gitws6qmn0ks">
      <div className="mx-auto max-w-[820px] px-5 md:px-8" data-id="element-34" data-mp="249g57z4jmmvb">
        <SectionHeading id="faq-title" eyebrow={faq.eyebrow} title={faq.title} data-id="element-35" data-mp="249zkt96q0z66" />

        <ul className="mt-8 space-y-2.5 md:mt-10" data-id="element-36" data-mp="289hxxisaw5yg">
          {faq.items.map((item, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          const buttonId = `faq-button-${i}`;
          return <li key={item.q} className={`rounded-xl border bg-white transition-colors duration-150 ease-out ${isOpen ? 'border-orange' : 'border-cream-line'}`} data-id="element-37" data-mp="2n822t40upvuh" data-mpi={i}>
                <h3 data-id="element-38" data-mp="14usgd3dt2mvi">
                  <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex min-h-[60px] w-full items-center justify-between gap-4 rounded-xl px-4 py-4 text-left text-[16px] font-semibold text-teal focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange md:px-6 md:text-[17px]" data-id="element-39" data-mp="14wbw8svjuvwr">
                    {item.q}
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out ${isOpen ? 'bg-orange text-white' : 'bg-teal-tint text-teal'}`} data-id="element-40" data-mp="1xkhi5iycaqy6">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} strokeWidth={2.5} aria-hidden="true" data-id="element-41" data-mp="366qz3u9vkp8" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-42" data-mp="287iyzryrst6n">
                  {isOpen && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-43" data-mp="289nb2x6toyi0">
                      <p className="px-4 pb-5 text-[16px] leading-relaxed text-ink/75 md:px-6" data-id="element-44" data-mp="2vw25c1y9evw3">{item.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}